import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { MeService, UserRoleResponseDto } from '@api';

import { CoreStorageService } from 'pn-core-code';

@Injectable({
  providedIn: 'root'
})
export class GlobalDataService {

  public userProfileSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  public focusUserGroupSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  userProfile: any;

  constructor(
    private storage: CoreStorageService,
    private meService: MeService,
  ) { }

  setUserProfile() {
    this.meService.meGet$()
      .subscribe(data => {
        try {
          // console.log('setFocusUser 27', data);
          const userString = JSON.stringify(data);
          this.storage.setItem('user', userString);
          this.userProfileSubject.next(data);
        } catch (error) {
          console.log('error setFocusCustomer', error);
        }

      });

    // const tempUser = this.storage.getItem('user');
    // if (tempUser) {
    //   const data = JSON.parse(tempUser);
    //   console.log('user.dataa', data);

    //   if (data.username === 'executivewpn') {
    //     this.userProfile = { id: 2, name: 'USER Executive WPN', permission: 'WPN' };
    //   } else if (data.username === 'centralwpn') {
    //     this.userProfile = { id: 2, name: 'USER Central WPN', permission: 'WPN' };
    //   } else if (data.username === 'employeewpn') {
    //     this.userProfile = { id: 2, name: 'USER Employee', permission: 'WPN_BRANCH' };
    //   } else if (data.username === 'executivefranchise') {
    //     this.userProfile = { id: 2, name: 'USER Executive FRANCHISE', permission: 'FRANCHISE' };
    //   } else if (data.username === 'employeefranchise') {
    //     this.userProfile = { id: 2, name: 'USER Employee FRANCHISE ', permission: 'FRANCHISE_BRANCH' };
    //   } else {
    //     this.userProfile = { id: 1, name: 'USER WPN', permission: 'WPN' };
    //   }
    //   this.userProfileSubject.next(data);
    // } else {
    //   // this.setUserProfile();
    //   // this.userProfileSubject.next(this.userProfile);
    // }



    // this.userProfile = { id: 2, name:'USER WPN_BRANCH', permission: 'WPN_BRANCH' };
    // this.userProfile = { id: 3,  name:'USER FRANCHISE',permission: 'FRANCHISE' };
    // this.userProfile = { id: 4, name:'USER FRANCHISE_BRANCH', permission: 'FRANCHISE_BRANCH' };
    // this.userProfileSubject.next(this.userProfile);
  }

  getUserProfile() {
    const userProfile = this.storage.getItem('user');
    // console.log('userProfile 73', userProfile);
    if (userProfile) {
      this.userProfileSubject.next(JSON.parse(userProfile));
    } else {
      this.setUserProfile();
    }
  }


  setFocusUserGroup(userRoles: UserRoleResponseDto) {
    // console.log('setFocusUserGroup 81', userRoles)
    if (userRoles) {
      const data = JSON.stringify(userRoles);
      // console.log('data 81', data)
      this.storage.setItem('focus_user_group', data);
      this.focusUserGroupSubject.next(data);
    }

  }

  getFocusUserGroup() {
    const focusUserGroup = this.storage.getItem('focus_user_group');
    // console.log('setFocusUserGroup 92', focusUserGroup)
    if (focusUserGroup) {
      this.focusUserGroupSubject.next(JSON.parse(focusUserGroup));
    }
  }


}
